<template>
<div class="c-step step-11">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      <p>
        <strong>
          Wybierz jaki ma być to upominek?
        </strong>
      </p>
      <div>
        <div class="c-step-option" v-on:click="setGift('Kwiaty')" v-bind:class="{ 'selected' : checkGift('Kwiaty') }">
          Kwiaty
        </div>
        <div class="c-step-option" v-on:click="setGift('Kokarda')" v-bind:class="{ 'selected' : checkGift('Kokarda') }">
          Kokarda
        </div>
        <div class="c-step-option" v-on:click="setGift('Maskotka')" v-bind:class="{ 'selected' : checkGift('Maskotka')}">
          Maskotka
        </div>
        <div class="c-step-option" v-on:click="setGift('Gadżety')" v-bind:class="{ 'selected' : checkGift('Gadżety')}">
          Gadżety
        </div>
        <div class="c-step-option" v-on:click="setGift('Pełen bak')" v-bind:class="{ 'selected' : checkGift('Pełen bak')}">
          Pełen bak
        </div>
      </div>
    </div>
  </div>
  <div class="c-step-answers">
    <button v-if="answerInput" v-on:click="answer(answerInput)">Dalej</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step11',
  data() {
    return {
      answerInput: []
    }
  },
  methods: {
    setGift(data) {
      if (_.includes(this.answerInput, data)) {
        this.answerInput.splice(this.answerInput.indexOf(data), 1);
      } else {
        _.extend(this.answerInput, {
          [_.size(this.answerInput)]: data
        });
        this.answerInput = _.values(this.answerInput);
      }
    },
    checkGift(value) {
      return _.includes(this.answerInput, value)
    },
    answer(answer) {
      this.$store.dispatch('answer', {
        step: '13',
        answer: answer,
        finish: true
      })
    }
  },
  components: {
    'stepsCounter': stepsCounter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
